import { Cache } from "memory-cache";
import { CharacterPlanetEntity } from ".";

// Cache
const cache = new Cache();
export async function getCachedCharacterPlanetEntity(
  character_id: number,
  planet_id: number
): Promise<CharacterPlanetEntity | null> {
  let entity: any = await cache.get("planet-" + character_id.toString() + "-" + planet_id.toString());
  if (entity) {
    return entity;
  }
  return null;
}
export function setCachedCharacterPlanetEntity(character_id: number, planet: CharacterPlanetEntity) {
  cache.put("planet-" + character_id.toString() + "-" + planet.props.id, planet, 60 * 60 * 1000 /* 1 hour */);
}
